<script>
  import {faExclamationTriangle} from '@fortawesome/free-solid-svg-icons'

  import EditHeader from '../generic/EditHeader.vue'

  export default {
    components: {
      EditHeader
    },
    data () {
      return {
        iconError: faExclamationTriangle
      }
    },
    computed: {
      isLoading () {
        return this.$store.getters[this.store + '/create/isLoading']
      },
      error () {
        return this.$store.getters[this.store + '/create/error']
      },
      violations () {
        return this.$store.getters[this.store + '/create/violations']
      },
      translations () {
        return this.translationRoot ? this.translationRoot : this.store.split('/')[0]
      },
    },
    beforeDestroy () {
        this.clear()
    },
    mounted () {
      this.clear()
    },
    methods: {
      clear () {
        this.$store.dispatch(this.store + '/create/clear').then(() => {
          this.$emit('reset')
        })
      },
      onSendForm () {
        this.$store.dispatch(this.store + '/create/save').then(
          (item) => {
            this.$store.dispatch('toasts/addToast', {
              variant: 'success',
              title: {message: `${this.translations}.toasts.create-success.title`, parameters: {...item}},
              content: {message: `${this.translations}.toasts.create-success.content`, parameters: {...item}},
              hideAfter: 5,
            })
            this.$router.replace({ name: this.updateRoute, params: { id: item['@id'] } })
          },
          (error) => {
            this.$store.dispatch('toasts/addToast', {
              variant: 'danger',
              title: {message: `${this.translations}.toasts.create-fail.title`, parameters: {error, ...this.$store.getters[this.store + '/create/item']}},
              content: {message: `${this.translations}.toasts.create-fail.content`, parameters: {error, ...this.$store.getters[this.store + '/create/item']}},
            })
          }
        )
      }
    },
    props: {
      store: {
        type: String,
        required: true
      },
      translationRoot: {
        type: String
      },
      updateRoute: {
        type: String,
        required: true
      }
    }
  }
</script>

<template>
  <form @submit.prevent="onSendForm" class="container-fluid" :disabled="isLoading">
    <edit-header :store="store" :show-delete="false">
    </edit-header>
    <b-row>
      <slot v-bind:store="store + '/create'"></slot>
    </b-row>
  </form>
</template>
